import React, { useState, useEffect, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { Paginator } from 'primereact/paginator';
import classNames from 'classnames';
import '../../assets/layout/styling.css'
import LoadingSpinner from "../Spinner/LoadingSpinner";
import exportData from "../../services/exportToExcelService";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Dropdown } from 'primereact/dropdown';

const Country = () => {

    let emptyCountry = {
        id: '',
        name: '',
    };

    // Hooks
    const [Countrylist, setCountrylist] = useState([]);
    const [id, setid] = useState('');
    const [CreatedBy, SetCreatedBy] = useState('');
    const [Created, SetCreated] = useState('');
    const [countryData, setCountrydata] = useState(emptyCountry);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [countryFilter, setcountryFilter] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([]);

    // Flags
    const [AddnewDialog, setAddnewDialog] = useState(false);    // Adding New Country
    const [deleteDialog, setdeleteDialog] = useState(false);  // Deleting New Country
    const [submitted, setSubmitted] = useState(false);   //Checking Submitted Or Not
    const [isExportExcel, setIsExportExcel] = useState(false);
    const [filterDialog, setFilterDialog] = useState(false);

    // Const
    const UserName = localStorage.getItem('Username');
    // const date = new Date();
    const toast = useRef(null);
    const dt = useRef(null);
    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: 1,
        country: null
    }); // For Sorting And Pagination Purpose

    // On Screen Load
    useEffect(() => {
        getcountrylist();
        if (window.innerWidth > 991) {
            document.documentElement.style.setProperty('overflow', 'hidden');
        } else {
            document.documentElement.style.setProperty('overflow', 'auto');
        }
        return () => {
            document.documentElement.style.setProperty('overflow', 'auto');
        };
    }, []);

    // - All Api

    // Get All Country
    const getcountrylist = (isExportExcel = false, event) => {
        setIsLoading(true);
        if (!isExportExcel) setCountrylist([]);
        axios.post('/api/Country/GetAll', {
            paginationRequired: !isExportExcel,
            SortDirection: lazyState.current.sortOrder,
            PageSize: lazyState.current.rows,
            CurrentPageNumber: event && event.rows ? ((event.first / event.rows) + 1) : lazyState.current.page,
            SortField: event ? event.sortField : "name",
            Country: lazyState.current.country ? lazyState.current.country.trim() : null,
        }).then(Response => {
            if (!isExportExcel) setCountrylist([]);
            let tempData = [];
            for (let dataObj of Response.data.data) {
                // Pass body data in excelsheets.
                let allExcelData;
                let excelcolumnData = {
                    // Id: dataObj.id,
                    Name: dataObj.name,
                };
                if (selectedColumns.length > 0) {
                    for (let selectedColumn of selectedColumns) {
                        let fieldName = selectedColumn.field;
                        let headerName = selectedColumn.header;
                        excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                    };
                    tempData.push(excelcolumnData);
                } else {
                    allExcelData = {
                        // Id: dataObj.id,
                        Name: dataObj.name,
                    };
                    tempData.push(allExcelData);
                };
            };
            if (isExportExcel) {
                exportData(tempData, 'Country');
                setIsLoading(false);
                return false;
            };
            setTotalRecords(Response.data.totalRecords);
            setCountrylist(Response.data.data);
            setIsLoading(false);
        })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
            });
    };

    // Get By Id
    const getcountrybyid = (id) => {
        setIsLoading(true);
        axios.get('/api/Country/GetAsync/' + id)
            .then((Response) => {
                setid(Response.data.id);
                SetCreatedBy(Response.data.createdBy);
                SetCreated(Response.data.created);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
            });
    };

    // Add New Country
    const Insertupdatecountry = () => {
        setSubmitted(true);
        if (countryData.id == '') {
            if (countryData.name.trim()) {
                const url = '/api/Country/Insert';
                const data = {
                    "Name": countryData.name?.toUpperCase().trim(),
                    "CreatedBy": UserName?.toUpperCase(),
                    // "Created": date,
                };
                axios.post(url, data)
                    .then(() => {
                        setAddnewDialog(false);
                        getcountrylist(isExportExcel, lazyState.current);
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'New Country Added', life: 3000 });
                        // document.documentElement.style.setProperty('overflow', 'auto')
                    }).catch((error) => {
                        if (error.response.data.includes("System.Exception: Country With This Name Already Exist.")) {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Country Already Exist', life: 3000 });
                        }
                        else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                        };
                    });
            };

        };
        if (countryData.id) {
            const url = '/api/Country/Update';
            const data = {
                "id": countryData.id,
                "Name": countryData.name?.toUpperCase().trim(),
                "CreatedBy": CreatedBy?.toUpperCase(),
                "Created": Created,
                "ModifiedBy": UserName?.toUpperCase(),
                // "Modified": date
            };
            axios.put(url, data)
                .then(() => {
                    setAddnewDialog(false);
                    getcountrylist(isExportExcel, lazyState.current);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Country Updated', life: 3000 });
                    // document.documentElement.style.setProperty('overflow', 'auto')
                }).catch((error) => {
                    if (error.response.data.includes("System.Exception: Country With This Name Already Exist.")) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Country Already Exist', life: 3000 });
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
                    }
                });
        };
    };

    // To Delete Country
    const Deletecountry = () => {
        setIsLoading(true);
        setCountrydata(emptyCountry);
        axios.delete('/api/Country/Delete/' + id)
            .then((result) => {
                if (result.status === 200) {
                    setdeleteDialog(false);
                    getcountrylist(isExportExcel, lazyState.current);
                    setIsLoading(false);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Country Deleted', life: 3000 });
                    // document.documentElement.style.setProperty('overflow', 'auto');
                };
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    // Functions

    // On Add New Country
    const openNew = () => {
        // document.documentElement.style.setProperty('overflow', 'hidden') 
        setCountrydata(emptyCountry);
        setSubmitted(false);
        setAddnewDialog(true);
    };

    // On Edit Country
    const editProduct = (country) => {
        // document.documentElement.style.setProperty('overflow', 'hidden') 
        setAddnewDialog(true);
        getcountrybyid(country.id);
        let _Country = { ...country };
        _Country['id'] = (country.id) || '';
        _Country['name'] = (country.name) || '';
        setCountrydata(_Country);
    };

    // On Delete Country
    const confirmDeleteProduct = (country) => {
        // document.documentElement.style.setProperty('overflow', 'hidden') 
        setdeleteDialog(true);
        setCountrydata(country);
        getcountrybyid(country.id);
    };

    // On Hide Dialog For Edit / Add Country
    const hideDialog = () => {
        // document.documentElement.style.setProperty('overflow', 'auto'); 
        setAddnewDialog(false);
        setSubmitted(false);
    };

    // On Hide Delete Dialog
    const hideDeleteProductDialog = () => {
        // document.documentElement.style.setProperty('overflow', 'auto') 
        setdeleteDialog(false);
    };

    // For Sorting 
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getcountrylist(isExportExcel, lazyState.current);
    };

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
            setIsLoading(true);
            lazyState.current.sortField = lazyState.current.sortField;
            lazyState.current.sortOrder = lazyState.current.sortOrder;
            lazyState.current.first = event.first;
            lazyState.current.rows = event.rows;
            getcountrylist(isExportExcel, lazyState.current);
            setIsLoading(false);
        // }
    };

    //Template for pagination
    const template2 = {
        layout: ' CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (
                <span className="paginator-current-report" style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'center' }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            );
        },
        RowsPerPageDropdown: (options) => {
            return <span className="paginator-rows-per-page">Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} /></span>;
        },
    };

    // All Buttons

    // Edit And Delete Buttons
    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <AccessControl allowedPermissions={["edit:country"]}>
                    <Button icon="fa fa-pencil" className="p-button-rounded mr-2" onClick={() => editProduct(rowData)} tooltip="Edit" tooltipOptions={{ position: 'bottom' }} outlined />
                </AccessControl>
                <AccessControl allowedPermissions={["delete:country"]}>
                    <Button icon="fa fa-trash" className="p-button-rounded mr-2" onClick={() => confirmDeleteProduct(rowData)} tooltip="Delete" tooltipOptions={{ position: 'bottom' }} outlined />
                </AccessControl>
            </div>
        );
    };

    // Modals Button To Add Country
    const productDialogFooter = (
        <>
            <Button label="Save" icon="fa fa-check" onClick={() => Insertupdatecountry(id)} outlined />
            <Button label="Cancel" icon="fa fa-times" onClick={(e) => { hideDialog(e) ;setAddnewDialog(false)  }} outlined />
        </>
    );

    // Delete Confirmation Button
    const deleteProductDialogFooter = (
        <>
            <Button label="Yes" icon="fa fa-check" onClick={() => Deletecountry(id)} outlined />
            <Button label="No" autoFocus icon="fa fa-times" onClick={() => hideDeleteProductDialog(false)} outlined />
        </>
    );

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <AccessControl allowedPermissions={["add:country"]}>
                <div className="my-2">
                    <Button label="Add Country" icon="fa fa-plus" onClick={openNew} outlined />
                </div>
            </AccessControl>
        );
    };

    //On Input Change In Text Box Of Country
    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value);
        let _Country = { ...countryData };
        _Country[`${name}`] = val;
        setCountrydata(_Country);
    };

    const CountryFilteronEnter = (e) => {
        if (e.key == "Enter") {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setIsLoading(true);
                lazyState.current.country = e.target.value ? e.target.value : null
                getcountrylist(isExportExcel, lazyState.current);
            } else {
                setIsLoading(true);
                lazyState.current.country = null
                getcountrylist(isExportExcel, lazyState.current);
            };
        };
    };

    const CountryNameFilter = () => {
        return (
            <InputText name="countryname" value={countryFilter} placeholder="Enter Country" onChange={(e) => setcountryFilter(e.target.value)}
                onKeyDown={(e) => CountryFilteronEnter(e)} className="country-filter-input" style={{ width: '100%', maxWidth: '250px' }}></InputText>
        );
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2">
                <AccessControl allowedPermissions={["list:country"]}>
                    <Button
                        icon="pi pi-filter"
                        label="Filter"
                        className="p-button-outlined mr-2 mobile-only-btn"
                        onClick={() => setFilterDialog(true)}
                        tooltip="Filter"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        outlined
                    />
                    <Button disabled={lazyState.current.country == null ? true : false} icon="pi pi-filter-slash" className="mr-2" onClick={(e) => { lazyState.current.country = null; setcountryFilter(""); getcountrylist(isExportExcel, lazyState.current) }} tooltip="Reset Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} outlined></Button>
                </AccessControl>
                <AccessControl allowedPermissions={["export:country"]}>
                    <Button disabled={!(Countrylist != null && Countrylist.length > 0)} tooltip="Export Excel" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={() => { getcountrylist(true); }} icon="pi pi-file-excel" className="mr-2" outlined />
                </AccessControl>
            </div>
        )
    };

    const SearchFilter = () => {
        lazyState.current.country = countryFilter ? countryFilter : null;
        getcountrylist(isExportExcel, lazyState.current);
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.5rem' }}>
            <Button
                label="Reset"
                icon="pi pi-filter-slash"
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                    lazyState.current.country = null;
                    setcountryFilter("");
                    getcountrylist(isExportExcel, lazyState.current);
                    setFilterDialog(false);
                }}
                outlined
            />
            <Button
                label="Apply"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={() => SearchFilter()}
            />
        </div>
    );

    // Html Part
    return (
        <AccessControl allowedPermissions={["list:country"]} renderNoAccess={() => <NoAccess />} >
            <div className="trico-Grid">
                <Toast ref={toast} />
                {isLoading ? <LoadingSpinner /> :
                    (
                        <>
                            <div className="p-col">
                                <div className="card">
                                    <h5 className="headerfont"><span><i className="fa fa-solid fa-cog mr-2"></i>Country</span></h5>
                                    <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                    <div className="attendee-status-desktop-table">
                                        <DataTable size="small" stripedRows ref={dt} value={Countrylist} lazy rows={lazyState.current.rows}
                                            onSort={onSort} sortField={lazyState.current.sortField} sortOrder={lazyState.current.sortOrder}
                                            removableSort filterDisplay={"row"} scrollable scrollHeight="calc(100vh - 250px)"
                                            dataKey="id" className="datatable-responsive country-datatable" responsiveLayout="scroll">
                                            <Column field="name" header="Name" sortable sortField="name" headerStyle={{ width: '80%', minWidth: '10rem' }} filter filterElement={CountryNameFilter} showFilterMenu={false}></Column>
                                            <Column header="Action" body={actionBodyTemplate} headerStyle={{ width: '20%', minWidth: '6rem' }}></Column>
                                        </DataTable>
                                    </div>
                                    <div className="attendee-status-mobile-cards">
                                        <div className="attendee-card-grid">
                                            {Countrylist && Countrylist.length > 0 ? (
                                                Countrylist.map((row) => {
                                                    return (
                                                        <div key={row.id} className="attendee-mobile-card">
                                                            <div className="attendee-card-top">
                                                                <div className="attendee-card-top-left">
                                                                    <span className="attendee-card-id"><i className="fa fa-globe mr-1"></i>Country</span>
                                                                </div>
                                                                <div className="attendee-card-top-right">
                                                                    {actionBodyTemplate(row)}
                                                                </div>
                                                            </div>
                                                            <h6 className="attendee-card-name font-bold mb-0">{row.name || "-"}</h6>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="attendee-empty-state text-center p-4 card surface-card">
                                                    <i className="fa fa-inbox text-4xl text-400 mb-2"></i>
                                                    <p className="text-600 m-0">No records found</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <Paginator className='justify-content-end country-paginator' first={lazyState.current.first} rows={lazyState.current.rows} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange} ></Paginator>

                                    <Dialog visible={AddnewDialog} draggable={false} style={{ width: '450px', maxWidth: '95vw' }}
                                        breakpoints={{ '960px': '75vw', '640px': '92vw' }}
                                        header="Country Details"
                                        modal className="p-fluid country-dialog" footer={productDialogFooter} onHide={hideDialog}>
                                        <div className="field">
                                            <label id="label" htmlFor="Country">Country</label>
                                            <label id="Mandatoryfield" >*</label>
                                            <InputText maxLength="50" id="name" name="name" required autoFocus placeholder="Enter Country"
                                             value={countryData.name?.toUpperCase()} onChange={(e) => onInputChange(e, 'name')}
                                                className={classNames({ 'p-invalid': submitted && !countryData.name })} />
                                            {submitted && !countryData.name && <small className="p-invalid">Country is required.</small>}
                                        </div>
                                    </Dialog>

                                    <Dialog visible={deleteDialog} draggable={false} style={{ width: '450px', maxWidth: '95vw' }}
                                        breakpoints={{ '960px': '75vw', '640px': '92vw' }}
                                        header="Confirm" modal className="country-dialog" footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                                        <div className="flex align-items-center">
                                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                                            <span>Are you sure you want to delete <b>{countryData.name}</b> country? </span>
                                        </div>
                                    </Dialog>

                                    <Dialog
                                        visible={filterDialog}
                                        draggable={false}
                                        header={
                                            <div className="dialog-header-content flex align-items-center gap-2">
                                                <i className="fa fa-filter text-primary dialog-header-icon mr-2"></i>
                                                <span className="dialog-header-title">Filter Country</span>
                                            </div>
                                        }
                                        modal
                                        className="p-fluid admin-dialog attendee-filter-dialog"
                                        footer={filterDialogFooter}
                                        onHide={() => setFilterDialog(false)}
                                    >
                                        <div className="filter-dialog-grid">
                                            <div className="filter-field-item">
                                                <label>Country Name</label>
                                                <InputText value={countryFilter} placeholder="Enter Country" onChange={(e) => setcountryFilter(e.target.value)} />
                                            </div>
                                        </div>
                                    </Dialog>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </AccessControl>
    );
}

export default Country;